import React, { useState } from "react";
import CommonHeading from "../common/CommonHeading";
import { services } from "../data/Data";

export default function Services() {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <section className="services-section" aria-label="Our Services">
      <div className="container services-container">
        <div className="services-heading-wrapper">
          <CommonHeading
            heading="Our Services"
            title="Services"
            subtitle="Experience the Best of Rajasthan at"
          />
        </div>

        <div className="services-grid">
          {services.map((item, index) => (
            <article
              key={index}
              className={`service-card ${hoveredIndex === index ? "service-card--hover" : ""
                }`}
              tabIndex={0}
              aria-label={item.name}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              onFocus={() => setHoveredIndex(index)}
              onBlur={() => setHoveredIndex(null)}
            >
              <div className="service-icon-wrapper">{item.icon}</div>
              <h5 className="service-title">{item.name}</h5>
              <p className="service-description">{item.discription}</p>
            </article>
          ))}
        </div>
      </div>

      {/* Scoped styles */}
      <style>{`
        /* Section background – Jodhpur theme */
        .services-section {
          padding: 32px 0 10px 0;
          background: linear-gradient(
            180deg,
            #FAF6F0 0%,
            #F2EAE0 50%,
            #FAF6F0 100%
          );
        }

        .services-container {
          max-width: 1200px;
          margin: 0 auto;
        }

        .services-heading-wrapper {
          text-align: center;
        }

        /* Desktop: 3 in a row */
        .services-grid {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 2.4rem;
          margin-top: 1.5rem;
        }

        /* Tablet: 2 in a row */
        @media (max-width: 991.98px) {
          .services-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }
        }

        /* Mobile: 1 in a row */
        @media (max-width: 575.98px) {
          .services-grid {
            grid-template-columns: 1fr;
          }
        }

        /* Card – glassy, royal tones */
        .service-card {
          background: rgba(255, 255, 255, 0.98);
          border-radius: 24px;
          padding: 2.2rem 2rem;
          box-shadow: 0 12px 32px rgba(11, 29, 55, 0.08);
          text-align: center;
          color: #1A283B; /* deep blue-slate */
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          transition:
            transform 0.35s ease,
            box-shadow 0.35s ease,
            background 0.35s ease,
            border-color 0.35s ease;
          border: 1.5px solid rgba(30, 62, 114, 0.12);
          backdrop-filter: blur(10px);
        }

        .service-card--hover {
          transform: translateY(-8px) scale(1.02);
          box-shadow: 0 20px 48px rgba(30, 62, 114, 0.18);
          background: #ffffff;
          border-color: rgba(212, 175, 55, 0.65);
        }

        /* Icon circle – Rajasthani gold sun */
        .service-icon-wrapper {
          width: 82px;
          height: 82px;
          border-radius: 50%;
          margin-bottom: 1.4rem;
          background: linear-gradient(135deg, #FEA116, #D4AF37);
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 8px 24px rgba(254, 161, 22, 0.3);
        }

        .service-icon-wrapper i {
          font-size: 2rem;
          color: #050E1A;
        }

        .service-title {
          font-weight: 800;
          font-size: 1.25rem;
          margin-bottom: 0.7rem;
          color: #0B1D37;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          font-family: 'Cinzel', serif;
        }

        .service-description {
          font-size: 0.95rem;
          line-height: 1.7;
          color: #53647C;
          max-width: 320px;
          margin: 0 auto;
        }

        /* Tablet */
        @media (max-width: 991.98px) {
          .services-section {
            padding: 3.8rem 0 4rem;
          }

          .service-card {
            padding: 2rem 1.7rem;
          }

          .service-title {
            font-size: 1.15rem;
          }
        }

        /* Mobile */
        @media (max-width: 767.98px) {
          .services-section {
            padding: 3.2rem 0 3.6rem;
          }

          .services-grid {
            gap: 1.8rem;
          }

          .service-card {
            padding: 1.8rem 1.6rem;
            border-radius: 20px;
          }

          .service-icon-wrapper {
            width: 72px;
            height: 72px;
          }

          .service-title {
            font-size: 1.05rem;
          }

          .service-description {
            font-size: 0.95rem;
          }
        }

        /* Small mobiles */
        @media (max-width: 575.98px) {
          .services-grid {
            grid-template-columns: 1fr;
          }

          .service-card {
            padding: 1.6rem 1.4rem;
          }

          .service-icon-wrapper {
            width: 68px;
            height: 68px;
          }
        }
      `}</style>
    </section>
  );
}
